export function toArray<T>(value?: T | T[] | null): T[] {
  if (value === undefined || value === null)
    return [];

  return Array.isArray(value) ? value : [value];
}
